import { createStore } from "zustand/vanilla";
// Backs a deferred-delete Undo toast for an entity whose delete confirm navigates
// away immediately (template, trip): session-scoped (built once in SessionProvider)
// rather than page-local, since navigating away unmounts the page that would
// otherwise own the timer/toast. One instance per entity kind — `execute` is the only
// thing that differs between them.
const UNDO_WINDOW_MS = 6000;
export const createPendingDeleteStore = (deps) => {
    let timer = null;
    const cancelTimer = () => {
        if (timer === null)
            return;
        clearTimeout(timer);
        timer = null;
    };
    const store = createStore((set, get) => {
        // Fires the real write and only then drops `id` from `hiddenIds` — the id stays
        // hidden for the entire round-trip, not just until the timer fires.
        const commit = (id) => {
            void deps.execute(id).finally(() => {
                set((s) => ({ hiddenIds: s.hiddenIds.filter((x) => x !== id) }));
            });
        };
        return {
            pending: null,
            hiddenIds: [],
            arm(id, name) {
                const prior = get().pending;
                cancelTimer();
                set((s) => ({ pending: { id, name }, hiddenIds: [...s.hiddenIds, id] }));
                timer = setTimeout(() => {
                    timer = null;
                    set({ pending: null });
                    commit(id);
                }, UNDO_WINDOW_MS);
                // Flushing after arming the new one: the prior entry's own delete fires right
                // away rather than being silently dropped, and the toast has already moved on
                // to naming the new pending delete.
                if (prior !== null)
                    commit(prior.id);
            },
            undo() {
                const current = get().pending;
                cancelTimer();
                set((s) => ({
                    pending: null,
                    hiddenIds: current !== null ? s.hiddenIds.filter((x) => x !== current.id) : s.hiddenIds,
                }));
            },
            dispose() {
                cancelTimer();
                set({ pending: null });
            },
        };
    });
    return store;
};
//# sourceMappingURL=pendingDeleteStore.js.map